import { ChangeDetectionStrategy, Component } from "@angular/core";
import { HaModalService } from "@ha/ui/common";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PushNotificationSelectors } from "../../states/push-notification.selectors";
import { UnreadNotificationsModalComponent } from "../notification-header/unread-notifications-modal.component";

@Component({
    selector: "ntf-notification-header",
    templateUrl: "./notification-header.component.html",
    styleUrls: ["./notification-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationHeaderComponent {
    @Select(PushNotificationSelectors.unreadCount)
    public unreadCount$: Observable<number>;

    @Select(PushNotificationSelectors.hasUnreadNotifications)
    public hasUnreadNotifications$: Observable<boolean>;

    constructor(private store: Store, private modalService: HaModalService) {}

    public openNotificationsModal(): void {
        this.modalService.open(UnreadNotificationsModalComponent, true);
    }
}
